module.exports = __webpack_public_path__ + "static/media/StarBlue.9cc5d1f2.svg";